export var VcGlobal=VcGlobal || {}
VcGlobal.SERVER_ROOT="https://weather.visualcrossing.com"; //"http://localhost:8080"; //
VcGlobal.TILE_SERVER_ROOT="https://maps.visualcrossing.com"; //"http://localhost:8080"; //  
VcGlobal.AI_PROXY_SERVER_PATH="https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/"; //"http://localhost:8080/VisualCrossingWebServices/rest/services/"; // // //"https://weather1.visualcrossing.com";
VcGlobal.GLOBAL_KEY="8A4XDQBVPKGQMPJJ9387M3789"; 
VcGlobal.MAP_TILE_KEY="4UXQMWSDV5KEMM6JR2SC2FC8P";
VcGlobal.stripeKey="pk_live_4nUTPRcrDEg1t2OLcfsXmyKQ";
VcGlobal.VERSION="1.0.22.14";